module.exports = __webpack_public_path__ + "static/media/CTLI_16-178w.230aa2c0.webp";